// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application--wrap{margin-top:env(safe-area-inset-top)}.v-navigation-drawer__content{padding-top:env(safe-area-inset-top)}", ""]);
// Exports
module.exports = exports;
